/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DatachangeMultiData } from './datachangeMultiData';


/**
 * datachange the data that has been edited (or not, if action equals \"cancel\")
 */
export interface DatachangeMultiDataEdited { 
    /**
     * the action to be done (\"save\" or \"cancel\")
     */
    action: string;
    multiData?: Array<DatachangeMultiData>;
}

